import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/career";

export const careerApi = {
  listJobs: (params?: PaginatedParams & { type?: string; location?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.sort) searchParams.set("sort", params.sort);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.type) searchParams.set("type", params.type);
    if (params?.location) searchParams.set("location", params.location);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/jobs?${searchParams.toString()}`);
  },

  getJob: (id: string) => apiGet<{ job: Record<string, unknown> }>(`${BASE}/jobs/${id}`),

  apply: (jobId: string, data: Record<string, unknown>) =>
    apiPost<{ application: Record<string, unknown> }>(`${BASE}/jobs/${jobId}/apply`, data),

  withdrawApplication: (jobId: string, applicationId: string) =>
    apiDelete<{ message: string }>(`${BASE}/jobs/${jobId}/applications/${applicationId}`),

  getApplications: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/applications?${searchParams.toString()}`);
  },

  getAssessments: () => apiGet<{ assessments: Record<string, unknown>[] }>(`${BASE}/assessments`),

  startAssessment: (assessmentId: string) =>
    apiPost<{ assessment: Record<string, unknown> }>(`${BASE}/assessments/${assessmentId}/start`),

  submitAssessment: (assessmentId: string, data: Record<string, unknown>) =>
    apiPost<{ result: Record<string, unknown> }>(`${BASE}/assessments/${assessmentId}/submit`, data),

  getProfile: () => apiGet<{ profile: Record<string, unknown> }>(`${BASE}/profile`),

  updateProfile: (data: Record<string, unknown>) =>
    apiPut<{ profile: Record<string, unknown> }>(`${BASE}/profile`, data),
};
